import { Component, EventEmitter, Injector, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { GbgrundstueckService, GrundstueckSearchRequestGsNummerMeta } from '../../../core/gb-api';
import { ActivatedRoute, Router } from '@angular/router';
import { GbGemeindeSearchMode as GbGemeindeSearchMode } from '../../../shared/widgets/gb-gemeinde/gbGemeindeSearchMode';
import { GrundstueckFormService } from '../../grundstueck-form-service';
import { GrundstueckNummerComponent } from '../../../shared/widgets/grundstueck-nummer/grundstueck-nummer.component';
import { TimepointService } from '../../../core/services/timepoint.service';
import { Subscription } from 'rxjs';
import { AbstractSearchComponent } from '../../../shared/components/abstract-component/abstract-search.component';
import { SearchStateService } from '../../../shared/services/search-state.service';
import { SearchMode } from '../../../shared/enum/searchMode';
import { MetaDirective } from '../../../shared/directives/meta.directive';
import { MetaDisablerDirective } from '../../../shared/directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../../shared/directives/meta-validator.directive';
import { GrundstueckSelectionComponent } from '../../../shared/widgets/grundstuecktype-selection/grundstuecktype-selection.component';
import { HistoryOptionsComponent } from '../../../shared/widgets/history-options/history-options.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-grundstueck-suche-standard',
  templateUrl: './grundstueck-suche-standard.component.html',
  styleUrls: ['./grundstueck-suche-standard.component.scss'],
  imports: [
    FormsModule,
    MetaDirective,
    GrundstueckNummerComponent,
    MetaDisablerDirective,
    MetaValidatorDirective,
    GrundstueckSelectionComponent,
    HistoryOptionsComponent,
    TranslatePipe
  ]
})
export class GrundstueckSucheStandardComponent extends AbstractSearchComponent implements OnInit, OnDestroy {
  @ViewChild('form', { static: false })
  form: NgForm;

  @Output()
  tabErweitertActive: EventEmitter<boolean> = new EventEmitter<boolean>();

  @ViewChild(GrundstueckNummerComponent, { static: false })
  private gsNummerComponent: GrundstueckNummerComponent;

  gsNummer: GrundstueckSearchRequestGsNummerMeta;
  gbGemeindeSearchMode = GbGemeindeSearchMode.GRUNDSTEUCK_REGISTER_SEARCH;
  hasRightMassenabfrage = true;

  private subscription: Subscription;

  constructor(
    private grundstueckService: GbgrundstueckService,
    private formService: GrundstueckFormService,
    stateService: SearchStateService,
    private route: ActivatedRoute,
    private router: Router,
    private timpointService: TimepointService,
    private injector: Injector
  ) {
    super(stateService);
  }

  ngOnInit() {
    if (this.stateService.lastRequest && this.stateService.lastSearchMode === SearchMode.searchStandard) {
      this.gsNummer = this.stateService.lastRequest;
    } else {
      this.gsNummer = <GrundstueckSearchRequestGsNummerMeta>{};
    }

    this.subscription = this.grundstueckService.searchGrundstueckGsNummerTemplate().subscribe((template) => {
      this.gsNummer = this.copyLastRequest(template);
    });
  }

  onSubmit(): void {
    this.stateService.lastRequest = this.gsNummer;
    this.timpointService.resetTimepoint();
    this.formService.submit(this.form, SearchMode.searchStandard, this.gsNummer, this.router, this.route, true);
  }

  onReset() {
    this.form.reset();
    this.subscription = this.grundstueckService.searchGrundstueckGsNummerTemplate().subscribe((template) => {
      this.gsNummer = template;
      this.gsNummerComponent.focus();
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
